// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import {
  getAuth,
  signInWithPopup,
  GoogleAuthProvider,
  OAuthProvider,
  signOut
} from 'firebase/auth';

import process from 'process';

// import { getAnalytics } from 'firebase/analytics';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
};

// Initialize Firebase
const firebaseApp = initializeApp(firebaseConfig);

const provider = new GoogleAuthProvider();
const appleProvider = new OAuthProvider('apple.com');

appleProvider.addScope('email');
appleProvider.addScope('name');

const db = getFirestore(firebaseApp);

const auth = getAuth();

const signInWithGoogle = () => {
  console.log('🔵 Attempting Google Sign-In...');
  console.log('🔵 Using Firebase Project:', process.env.REACT_APP_FIREBASE_PROJECT_ID);
  return signInWithPopup(auth, provider).catch((error) => {
    console.error('🔴 Google Sign-In Error Code:', error.code);
    console.error('🔴 Google Sign-In Error Message:', error.message);
    console.error('🔴 Full Error:', error);
    throw error;
  });
};

const signOutFromApp = () => {
  return signOut(auth);
};

const signInWithApple = () => {
  return signInWithPopup(auth, appleProvider);
};

const getToken = () => {
  return auth?.currentUser?.getIdTokenResult();
};

export { firebaseApp, auth, db, signInWithGoogle, signInWithApple, signOutFromApp, getToken };
